// src/hooks/productTypes/useForceDeleteProductType.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteProductType as forceDeleteProductTypeAPI } from "../../api/apiProductTypes";
import parseError from "../../utils/parseError";

const useForceDeleteProductType = () => {
    const queryClient = useQueryClient();

    const { mutate: forceDeleteProductType, isPending: isForceDelete } = useMutation({
        mutationFn: forceDeleteProductTypeAPI,
        onSuccess: (res) => {
            const message = res?.message || "Product type permanently deleted";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["productTypes"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to delete product type permanently");
        },
    });

    return { forceDeleteProductType, isForceDelete };
};

export default useForceDeleteProductType;